// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.msess {
    max-width: 1100px;
}

.msess-title {
    margin: 0 0 4px;
    font-size: 1.45rem;
    font-weight: 700;
    color: #0f172a;
}

.msess-sub {
    margin: 0 0 16px;
    color: #64748b;
    font-size: 0.95rem;
}

.msess-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 18px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 8px;
}

.msess-tab {
    border: 0;
    background: transparent;
    padding: 8px 14px;
    border-radius: 8px 8px 0 0;
    color: #64748b;
    font-weight: 600;
    font-size: 0.92rem;
    cursor: pointer;
}

.msess-tab:hover {
    color: #0f172a;
    background: #f1f5f9;
}

.msess-tab.is-active {
    color: #0f172a;
    background: #e2e8f0;
}

.msess-shell {
    padding: 28px 20px;
    border: 1px dashed #cbd5e1;
    border-radius: 12px;
    background: #f8fafc;
    color: #64748b;
    text-align: center;
}

.msess-shell strong {
    display: block;
    color: #334155;
    margin-bottom: 6px;
}

.msess-book-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(280px, 340px);
    gap: 20px;
    align-items: start;
}

@media (max-width: 900px) {
    .msess-book-layout {
        grid-template-columns: 1fr;
    }
}

.msess-cal-card,
.msess-confirm-card,
.msess-success-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #fff;
    padding: 16px 18px;
}

.msess-cal-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}

.msess-cal-month {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 700;
    color: #0f172a;
}

.msess-cal-nav {
    display: flex;
    gap: 6px;
}

.msess-cal-nav button {
    border: 1px solid #cbd5e1;
    background: #fff;
    border-radius: 8px;
    width: 34px;
    height: 34px;
    cursor: pointer;
    color: #334155;
}

.msess-cal-nav button:hover {
    background: #f1f5f9;
}

.msess-tz {
    margin: 0 0 12px;
    font-size: 0.82rem;
    color: #64748b;
}

.msess-cal-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 4px;
}

.msess-cal-dow {
    text-align: center;
    font-size: 0.72rem;
    font-weight: 700;
    color: #94a3b8;
    text-transform: uppercase;
    padding: 4px 0;
}

.msess-cal-day {
    border: 1px solid transparent;
    background: #f8fafc;
    border-radius: 8px;
    min-height: 44px;
    padding: 4px;
    cursor: default;
    color: #94a3b8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
}

.msess-cal-day.is-in-month {
    color: #0f172a;
    background: #fff;
    border-color: #e2e8f0;
}

.msess-cal-day.is-has-slots {
    border-color: #0e7490;
    background: #ecfeff;
    cursor: pointer;
}

.msess-cal-day.is-has-booked {
    border-color: #16a34a;
    background: #f0fdf4;
    cursor: pointer;
}

.msess-cal-day.is-past {
    opacity: 0.55;
    cursor: not-allowed;
}

.msess-cal-day.is-selected {
    outline: 2px solid #0f172a;
    outline-offset: 1px;
}

.msess-cal-day-num {
    font-size: 0.9rem;
    font-weight: 600;
}

.msess-cal-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #0e7490;
}

.msess-cal-dot.is-booked {
    background: #16a34a;
}

.msess-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin: 12px 0 0;
    font-size: 0.78rem;
    color: #64748b;
}

.msess-legend span::before {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 6px;
    vertical-align: middle;
}

.msess-legend-avail::before {
    background: #0e7490;
}

.msess-legend-booked::before {
    background: #16a34a;
}

.msess-legend-past::before {
    background: #cbd5e1;
}

.msess-slots {
    margin-top: 16px;
}

.msess-slots-title {
    margin: 0 0 8px;
    font-size: 0.95rem;
    font-weight: 700;
    color: #0f172a;
}

.msess-slot-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.msess-slot-pill {
    border: 1px solid #0e7490;
    background: #fff;
    color: #0f172a;
    border-radius: 999px;
    padding: 6px 12px;
    font-size: 0.85rem;
    cursor: pointer;
}

.msess-slot-pill:hover:not(:disabled) {
    background: #ecfeff;
}

.msess-slot-pill.is-selected {
    background: #0f172a;
    border-color: #0f172a;
    color: #fff;
}

.msess-slot-pill.is-booked {
    border-color: #16a34a;
    background: #dcfce7;
    color: #166534;
    cursor: pointer;
}

.msess-slot-pill.is-booked:hover:not(:disabled) {
    background: #bbf7d0;
}

.msess-slot-pill.is-booked.is-selected {
    background: #15803d;
    border-color: #15803d;
    color: #fff;
}

.msess-slot-pill:disabled,
.msess-slot-pill.is-past {
    border-color: #cbd5e1;
    color: #94a3b8;
    background: #f1f5f9;
    cursor: not-allowed;
}

.msess-confirm-title {
    margin: 0 0 10px;
    font-size: 1.05rem;
    font-weight: 700;
}

.msess-confirm-summary {
    margin: 0 0 14px;
    padding: 10px 12px;
    border-radius: 8px;
    background: #f8fafc;
    color: #334155;
    font-size: 0.9rem;
}

.msess-confirm-summary p {
    margin: 0 0 4px;
}

.msess-field {
    margin-bottom: 12px;
}

.msess-field label {
    display: block;
    font-size: 0.8rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 4px;
}

.msess-field input,
.msess-field textarea,
.msess-field select {
    width: 100%;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    padding: 8px 10px;
    font-size: 0.9rem;
}

.msess-field textarea {
    min-height: 72px;
    resize: vertical;
}

.msess-hint {
    margin: 4px 0 0;
    font-size: 0.75rem;
    color: #94a3b8;
}

.msess-error {
    margin: 0 0 10px;
    color: #b91c1c;
    font-size: 0.88rem;
}

.msess-confirm-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.msess-empty {
    padding: 28px 18px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    color: #64748b;
    text-align: center;
}

.msess-success-card h3 {
    margin: 0 0 8px;
    font-size: 1.05rem;
}

.msess-success-card p {
    margin: 0 0 6px;
    color: #334155;
    font-size: 0.9rem;
}

.msess-list-card {
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    background: #fff;
    padding: 16px 18px;
}

.msess-upcoming-list,
.msess-past-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.msess-upcoming-row,
.msess-past-row {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid #f1f5f9;
}

.msess-upcoming-row:last-child,
.msess-past-row:last-child {
    border-bottom: 0;
    padding-bottom: 0;
}

.msess-upcoming-when,
.msess-past-when {
    margin: 0 0 4px;
    font-weight: 700;
    color: #0f172a;
}

.msess-upcoming-meta,
.msess-past-meta {
    margin: 0 0 4px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    color: #64748b;
    font-size: 0.88rem;
}

.msess-upcoming-topic,
.msess-past-title {
    margin: 0 0 4px;
    color: #334155;
}

.msess-upcoming-agenda,
.msess-upcoming-booked,
.msess-recording-note {
    margin: 4px 0 0;
    font-size: 0.88rem;
    color: #64748b;
}

.msess-upcoming-actions,
.msess-past-actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
}

.msess-type-chip {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    background: #e2e8f0;
    color: #334155;
    font-size: 0.75rem;
    font-weight: 600;
}

.msess-muted {
    color: #94a3b8;
    font-size: 0.85rem;
}

.msess-stars .is-filled {
    color: #eab308;
}

.msess-stars .is-empty {
    color: #cbd5e1;
}

.msess-rated-block {
    margin-top: 8px;
}

.msess-rated-feedback {
    margin: 6px 0 0;
    font-style: italic;
    color: #64748b;
    font-size: 0.88rem;
}

.msess-rated-chip {
    display: inline-block;
    padding: 4px 10px;
    border-radius: 999px;
    background: #dcfce7;
    color: #166534;
    font-size: 0.8rem;
    font-weight: 600;
}

.msess-rate-pick {
    display: flex;
    gap: 4px;
}

.msess-rate-star {
    border: 0;
    background: transparent;
    font-size: 1.6rem;
    line-height: 1;
    color: #cbd5e1;
    cursor: pointer;
    padding: 0 2px;
}

.msess-rate-star.is-active {
    color: #eab308;
}

.msess-field-label {
    display: block;
    font-size: 0.8rem;
    font-weight: 600;
    color: #475569;
    margin-bottom: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/mentorship/mentee/menteeSessions.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,0DAA0D;IAC1D,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;;;IAGI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;;IAEI,qBAAqB;IACrB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,gCAAgC;AACpC;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,eAAe;IACf,aAAa;IACb,eAAe;IACf,QAAQ;IACR,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,cAAc;AAClB;;AAEA;;;IAGI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".msess {\n    max-width: 1100px;\n}\n\n.msess-title {\n    margin: 0 0 4px;\n    font-size: 1.45rem;\n    font-weight: 700;\n    color: #0f172a;\n}\n\n.msess-sub {\n    margin: 0 0 16px;\n    color: #64748b;\n    font-size: 0.95rem;\n}\n\n.msess-tabs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-bottom: 18px;\n    border-bottom: 1px solid #e2e8f0;\n    padding-bottom: 8px;\n}\n\n.msess-tab {\n    border: 0;\n    background: transparent;\n    padding: 8px 14px;\n    border-radius: 8px 8px 0 0;\n    color: #64748b;\n    font-weight: 600;\n    font-size: 0.92rem;\n    cursor: pointer;\n}\n\n.msess-tab:hover {\n    color: #0f172a;\n    background: #f1f5f9;\n}\n\n.msess-tab.is-active {\n    color: #0f172a;\n    background: #e2e8f0;\n}\n\n.msess-shell {\n    padding: 28px 20px;\n    border: 1px dashed #cbd5e1;\n    border-radius: 12px;\n    background: #f8fafc;\n    color: #64748b;\n    text-align: center;\n}\n\n.msess-shell strong {\n    display: block;\n    color: #334155;\n    margin-bottom: 6px;\n}\n\n.msess-book-layout {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) minmax(280px, 340px);\n    gap: 20px;\n    align-items: start;\n}\n\n@media (max-width: 900px) {\n    .msess-book-layout {\n        grid-template-columns: 1fr;\n    }\n}\n\n.msess-cal-card,\n.msess-confirm-card,\n.msess-success-card {\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    background: #fff;\n    padding: 16px 18px;\n}\n\n.msess-cal-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.msess-cal-month {\n    margin: 0;\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #0f172a;\n}\n\n.msess-cal-nav {\n    display: flex;\n    gap: 6px;\n}\n\n.msess-cal-nav button {\n    border: 1px solid #cbd5e1;\n    background: #fff;\n    border-radius: 8px;\n    width: 34px;\n    height: 34px;\n    cursor: pointer;\n    color: #334155;\n}\n\n.msess-cal-nav button:hover {\n    background: #f1f5f9;\n}\n\n.msess-tz {\n    margin: 0 0 12px;\n    font-size: 0.82rem;\n    color: #64748b;\n}\n\n.msess-cal-grid {\n    display: grid;\n    grid-template-columns: repeat(7, 1fr);\n    gap: 4px;\n}\n\n.msess-cal-dow {\n    text-align: center;\n    font-size: 0.72rem;\n    font-weight: 700;\n    color: #94a3b8;\n    text-transform: uppercase;\n    padding: 4px 0;\n}\n\n.msess-cal-day {\n    border: 1px solid transparent;\n    background: #f8fafc;\n    border-radius: 8px;\n    min-height: 44px;\n    padding: 4px;\n    cursor: default;\n    color: #94a3b8;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 2px;\n}\n\n.msess-cal-day.is-in-month {\n    color: #0f172a;\n    background: #fff;\n    border-color: #e2e8f0;\n}\n\n.msess-cal-day.is-has-slots {\n    border-color: #0e7490;\n    background: #ecfeff;\n    cursor: pointer;\n}\n\n.msess-cal-day.is-has-booked {\n    border-color: #16a34a;\n    background: #f0fdf4;\n    cursor: pointer;\n}\n\n.msess-cal-day.is-past {\n    opacity: 0.55;\n    cursor: not-allowed;\n}\n\n.msess-cal-day.is-selected {\n    outline: 2px solid #0f172a;\n    outline-offset: 1px;\n}\n\n.msess-cal-day-num {\n    font-size: 0.9rem;\n    font-weight: 600;\n}\n\n.msess-cal-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #0e7490;\n}\n\n.msess-cal-dot.is-booked {\n    background: #16a34a;\n}\n\n.msess-legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin: 12px 0 0;\n    font-size: 0.78rem;\n    color: #64748b;\n}\n\n.msess-legend span::before {\n    content: '';\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    margin-right: 6px;\n    vertical-align: middle;\n}\n\n.msess-legend-avail::before {\n    background: #0e7490;\n}\n\n.msess-legend-booked::before {\n    background: #16a34a;\n}\n\n.msess-legend-past::before {\n    background: #cbd5e1;\n}\n\n.msess-slots {\n    margin-top: 16px;\n}\n\n.msess-slots-title {\n    margin: 0 0 8px;\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: #0f172a;\n}\n\n.msess-slot-pills {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.msess-slot-pill {\n    border: 1px solid #0e7490;\n    background: #fff;\n    color: #0f172a;\n    border-radius: 999px;\n    padding: 6px 12px;\n    font-size: 0.85rem;\n    cursor: pointer;\n}\n\n.msess-slot-pill:hover:not(:disabled) {\n    background: #ecfeff;\n}\n\n.msess-slot-pill.is-selected {\n    background: #0f172a;\n    border-color: #0f172a;\n    color: #fff;\n}\n\n.msess-slot-pill.is-booked {\n    border-color: #16a34a;\n    background: #dcfce7;\n    color: #166534;\n    cursor: pointer;\n}\n\n.msess-slot-pill.is-booked:hover:not(:disabled) {\n    background: #bbf7d0;\n}\n\n.msess-slot-pill.is-booked.is-selected {\n    background: #15803d;\n    border-color: #15803d;\n    color: #fff;\n}\n\n.msess-slot-pill:disabled,\n.msess-slot-pill.is-past {\n    border-color: #cbd5e1;\n    color: #94a3b8;\n    background: #f1f5f9;\n    cursor: not-allowed;\n}\n\n.msess-confirm-title {\n    margin: 0 0 10px;\n    font-size: 1.05rem;\n    font-weight: 700;\n}\n\n.msess-confirm-summary {\n    margin: 0 0 14px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    background: #f8fafc;\n    color: #334155;\n    font-size: 0.9rem;\n}\n\n.msess-confirm-summary p {\n    margin: 0 0 4px;\n}\n\n.msess-field {\n    margin-bottom: 12px;\n}\n\n.msess-field label {\n    display: block;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: #475569;\n    margin-bottom: 4px;\n}\n\n.msess-field input,\n.msess-field textarea,\n.msess-field select {\n    width: 100%;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    padding: 8px 10px;\n    font-size: 0.9rem;\n}\n\n.msess-field textarea {\n    min-height: 72px;\n    resize: vertical;\n}\n\n.msess-hint {\n    margin: 4px 0 0;\n    font-size: 0.75rem;\n    color: #94a3b8;\n}\n\n.msess-error {\n    margin: 0 0 10px;\n    color: #b91c1c;\n    font-size: 0.88rem;\n}\n\n.msess-confirm-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.msess-empty {\n    padding: 28px 18px;\n    border-radius: 12px;\n    border: 1px solid #e2e8f0;\n    background: #f8fafc;\n    color: #64748b;\n    text-align: center;\n}\n\n.msess-success-card h3 {\n    margin: 0 0 8px;\n    font-size: 1.05rem;\n}\n\n.msess-success-card p {\n    margin: 0 0 6px;\n    color: #334155;\n    font-size: 0.9rem;\n}\n\n.msess-list-card {\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    background: #fff;\n    padding: 16px 18px;\n}\n\n.msess-upcoming-list,\n.msess-past-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.msess-upcoming-row,\n.msess-past-row {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 12px 0;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.msess-upcoming-row:last-child,\n.msess-past-row:last-child {\n    border-bottom: 0;\n    padding-bottom: 0;\n}\n\n.msess-upcoming-when,\n.msess-past-when {\n    margin: 0 0 4px;\n    font-weight: 700;\n    color: #0f172a;\n}\n\n.msess-upcoming-meta,\n.msess-past-meta {\n    margin: 0 0 4px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    color: #64748b;\n    font-size: 0.88rem;\n}\n\n.msess-upcoming-topic,\n.msess-past-title {\n    margin: 0 0 4px;\n    color: #334155;\n}\n\n.msess-upcoming-agenda,\n.msess-upcoming-booked,\n.msess-recording-note {\n    margin: 4px 0 0;\n    font-size: 0.88rem;\n    color: #64748b;\n}\n\n.msess-upcoming-actions,\n.msess-past-actions {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 8px;\n}\n\n.msess-type-chip {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 999px;\n    background: #e2e8f0;\n    color: #334155;\n    font-size: 0.75rem;\n    font-weight: 600;\n}\n\n.msess-muted {\n    color: #94a3b8;\n    font-size: 0.85rem;\n}\n\n.msess-stars .is-filled {\n    color: #eab308;\n}\n\n.msess-stars .is-empty {\n    color: #cbd5e1;\n}\n\n.msess-rated-block {\n    margin-top: 8px;\n}\n\n.msess-rated-feedback {\n    margin: 6px 0 0;\n    font-style: italic;\n    color: #64748b;\n    font-size: 0.88rem;\n}\n\n.msess-rated-chip {\n    display: inline-block;\n    padding: 4px 10px;\n    border-radius: 999px;\n    background: #dcfce7;\n    color: #166534;\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n\n.msess-rate-pick {\n    display: flex;\n    gap: 4px;\n}\n\n.msess-rate-star {\n    border: 0;\n    background: transparent;\n    font-size: 1.6rem;\n    line-height: 1;\n    color: #cbd5e1;\n    cursor: pointer;\n    padding: 0 2px;\n}\n\n.msess-rate-star.is-active {\n    color: #eab308;\n}\n\n.msess-field-label {\n    display: block;\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: #475569;\n    margin-bottom: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
